module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("76y5s"))).then(() => parcelRequire('d0iPb'));